//variablen muessen pro instanz angepasst werden
module.exports = {
    mantelUrl : 'https://mantel-api.mobile.documedias.systems/v2/conferences/',
    baseUrl: 'https://mantel-api.mobile.documedias.systems/v2/checkall/',
    baseUrlDownload: 'https://mantel-api.mobile.documedias.systems/v2/downloadall/',
    baseUrlCDN: "https://documedias-188ab.kxcdn.com/",
    api_url : 'https://coredev.api.documedias.systems/api/',
    appointment_api_url : '',//'https://dev.appointment.documedias.systems/api/',
    auth_url : 'https://auth.documedias.com/',
    FILE_SERVER_FOLDER : 'b4222936-3c68-408f-8ca4-f0521bfceabd',
    FILE_SERVER_URL : 'https://fileserver.documedias.systems/',
    VUE_APP_X_API_KEY : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMjAyMS0wMi0yNFQxMzowMzoyOC4zMDZaIiwiaWQiOjE1LCJpYXQiOjE2MTQxNzE4MDh9.s5MUeBBlZCyL1kDeegBSUpn7X0FelPnGlGg1pMbxu7c',
    vue_app_access_key : 'eyJhbGciOiJIUzM4NCIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjo5LCJjb25ncmVzc0lkIjoxLCJkYXRlIjoiMjAxOC0xMC0wMVQwOTo0Njo0MC42MDlaIiwiaWF0IjoxNTM4Mzg3MjAwfQ.1Z8vRJF2gZtCuLDEWxQhNyvlYHS6YZsdJxvoYGfyo112afY8CofuEBP4_jvIPXhc',
    cdnInitStamp: "2024-11-04T09:30:00.000Z",
    conference: '1622',
    short_name: 'techbio2025',
    full_name: 'TECHBIO 2025',
    api_version: 2, //change this to api version 2 for new conferences!!!
    conf_date : '12 – 16 November',
    auth_key : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoyOTc2LCJjb25ncmVzc0lkIjoxNjAxLCJkYXRlIjoiMjAyNS0wNi0xMlQwOTo1NDowOS4zODFaIiwiaWF0IjoxNzQ5NzIyMDQ5fQ.ZZzxwc7NjuVL6hJyeUAdA-hrTwmMHpoUL7ooLoniOAU',
    auth_dev_key : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoyOTc2LCJjb25ncmVzc0lkIjoxNjAxLCJkYXRlIjoiMjAyNS0wNi0xMlQwOTo1NDowOS4zODFaIiwiaWF0IjoxNzQ5NzIyMDQ5fQ.ZZzxwc7NjuVL6hJyeUAdA-hrTwmMHpoUL7ooLoniOAU',
    auth_dev_key_web : '',
    chat_url: 'https://techbio2025.chat.documedias.systems/api/',
    favorite_api_url: 'https://techbio2025.planner.documedias.systems/api/program/favorites',
    is_multi_conf_app: false, //set true for society or Conf2Go,
    secret_mf:'k3HM1qRe0K+0QX+Eq2JmDV+dTJKnhiQXxu3+7ORwbpA=',
    secret_bluedog: 'ITplW37I+q4g2ZevmHn5x]u0Ayf+oIoMJ6j7ENBar96VI',
    update_user_extra_url : 'https://userextra.cpa.documedias.com',
    main_color: '#14552d',
    is_app: false, //unbedingt anpassen bevor App deploy
    versionIOS:'v1.0.0 4',
    versionAndroid:'v1.0.0 4',
    loginRequired: false,
    hasMenuBar:false

}
